var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-pause",attrs:{"aria-hidden":"true","tabindex":"-1","role":"presentation","viewBox":"0 0 32 32"}},[_c('path',{attrs:{"fill":"#ffffff","d":"M27.637,32h-5.818V0h5.818V32L27.637,32z M10.182,32H4.363V0h5.818V32z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }